import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function LifeBuoyIcon(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g
        clipPath={`url(#${clipPathId}-a)`}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.0001 18.3337c4.6024 0 8.3333-3.731 8.3333-8.3334 0-4.60235-3.7309-8.33331-8.3333-8.33331-4.60239 0-8.33335 3.73096-8.33335 8.33331 0 4.6024 3.73096 8.3334 8.33335 8.3334Z" />
        <path d="M10.0001 13.3337c1.8409 0 3.3333-1.4924 3.3333-3.3334 0-1.84092-1.4924-3.33331-3.3333-3.33331-1.84097 0-3.33335 1.49239-3.33335 3.33331 0 1.841 1.49238 3.3334 3.33335 3.3334ZM4.1084 4.1084l3.53333 3.53333M12.3584 12.3584l3.5333 3.5333M12.3584 7.64173l3.5333-3.53333M12.3584 7.64186l2.9417-2.94166M4.1084 15.8917l3.53333-3.5333" />
      </g>
      <defs>
        <clipPath id={`${clipPathId}-a`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </Icon>
  );
}
